import React, { useCallback, useState } from "react";
import { defineMessages, FormattedMessage, FormattedDate } from "react-intl";
import styled from "styled-components";
import moment from "moment";
import axios from "http/customAxios";
import { Alert, Button } from "react-bootstrap";
import { SectionHeading } from "../../components/section-heading";
import { defaultFormMessages } from "../shared/crud/form";
import { defaultListMessages } from "../shared/crud/list";
import { useConfig } from "../../lib/config";
import { FullWidthLoader } from "../../components/full-width-loader";
import { withAuthorizationVerifier } from "../../components/authorization-verifier";
import { useUserProfile } from "../../components/user-profile-provider";

const messages = {
  ...defaultFormMessages,
  ...defaultListMessages,
  ...defineMessages({
    title: {
      id: "internalmenu.crmBeta.generateBillingReport",
      defaultMessage: "Generate billing report"
    },
    description: {
      id: "internalmenu.crmBeta.generateDescription",
      defaultMessage: "Solo se podrá generar el informe de"
    },
    button: {
      id: "internalmenu.crmBeta.generate",
      defaultMessage: "Generate report"
    },
    success: {
      id: "internalmenu.crmBeta.generationSuccess",
      defaultMessage: "Report generated successfully"
    },
    error: {
      id: "internalmenu.crmBeta.generationError",
      defaultMessage: "There was an error generating the report"
    },
  }),
};

const Container = styled.div`
  margin: 1rem;
  > * {
    margin: 1rem 0;
  }
`;

const StyledButton = styled(Button)`
  margin-right: 15px;
`;

function GenerateBillingReport() {
  const { apiEndpoint } = useConfig();
  const userProfile = useUserProfile();
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);
  const [success, setSuccess] = useState<boolean>(false);
  const billingReportDate = moment(new Date()).subtract(1, "month").format("YYYY-MM-DD");

  const generateBillingReport = useCallback(async () => {
    setLoading(true);
    setError(false);
    setSuccess(false);
    // TODO: replace with httpclient
    await axios.post(`${apiEndpoint}/api/billings/snapshot/${billingReportDate}`)
      .then(response => {
        if (response.status === 201 && response.data) {
          setSuccess(true);
        } else {
          setError(true);
        }
        setLoading(false);
      })
      .catch(error => {
        console.log(error);
        setError(true);
        setLoading(false);
      });
  }, [apiEndpoint, billingReportDate]);

  if (loading) {
    return <FullWidthLoader />;
  }

  return (
    <>
      <SectionHeading>
        <FormattedMessage {...messages.title} />
      </SectionHeading>
      <Container>
        <StyledButton variant="primary" type="button" onClick={generateBillingReport}>
          <FormattedMessage {...messages.button} />
        </StyledButton>
        <>
          <FormattedMessage {...messages.description } />{" "}
          <FormattedDate value={billingReportDate} month="long" />{" "}
          (<FormattedDate value={billingReportDate} year="numeric" />)
        </>
        {success && (
          <Alert variant="success">
            <strong>
              <FormattedMessage {...messages.success} />
            </strong>
          </Alert>
        )}
        {error && (
          <Alert variant="danger">
            <strong>
              <FormattedMessage {...messages.error} />
            </strong>
          </Alert>
        )}
      </Container>
    </>
  )
}

export default withAuthorizationVerifier(GenerateBillingReport);
